var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", staticStyle: { "line-height": "20px" } },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.downloadHeader()
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("mdfeTranslate.DownloadBaseInvoiceBasicInformation")
                )
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.processingPDFData()
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("mdfeTranslate.DownloadAllInvoiceInformation"))
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "pdfHeader" } }, [
        _c("div", { staticStyle: { display: "flex", color: "#000" } }, [
          _c("div", { staticStyle: { flex: "1" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex", border: "1px solid #000" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      padding: "10px",
                      display: "flex",
                      "flex-direction": "column",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        id: "ajlogo1",
                        src: require("@/assets/ajlogo1.svg"),
                        alt: "",
                      },
                    }),
                    _c("div", { staticStyle: { "font-weight": "bold" } }, [
                      _c("div", [_vm._v("CNPJ")]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.rowMDFEData.company.companyCnpj)),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      padding: "10px",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _c("div", { staticStyle: { "font-size": "18px" } }, [
                      _vm._v(_vm._s(_vm.rowMDFEData.company.companyName)),
                    ]),
                    _c("div", { staticStyle: { margin: "5px 0" } }, [
                      _vm._v(
                        _vm._s(_vm.rowMDFEData.company.address) +
                          ", " +
                          _vm._s(_vm.rowMDFEData.company.number)
                      ),
                    ]),
                    _c("div", { staticStyle: { margin: "5px 0" } }, [
                      _vm._v(
                        _vm._s(_vm.rowMDFEData.company.neighborhood) +
                          " - FONE: " +
                          _vm._s(_vm.rowMDFEData.company.telephone)
                      ),
                    ]),
                    _c("div", { staticStyle: { margin: "5px 0" } }, [
                      _vm._v(
                        _vm._s(_vm.rowMDFEData.company.city) +
                          " - " +
                          _vm._s(_vm.rowMDFEData.company.state) +
                          " - CEP: " +
                          _vm._s(_vm.rowMDFEData.company.zipcode)
                      ),
                    ]),
                    _c("div", { staticStyle: { margin: "5px 0" } }, [
                      _vm._v(_vm._s(_vm.rowMDFEData.company.email)),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _c("div", [_vm._v("IE")]),
                        _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.company.ie))]),
                      ]),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _c("div", [_vm._v("RNTRC")]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.rowMDFEData.company.rntrc)),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "font-weight": "bold" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      border: "1px solid #000",
                      padding: "10px",
                    },
                  },
                  [
                    _c("div", [_vm._v("ORIGEM PRESTAÇÃO")]),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.rowMDFEData.startCityName) +
                          " / " +
                          _vm._s(_vm.rowMDFEData.startUf)
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      border: "1px solid #000",
                      padding: "10px",
                    },
                  },
                  [
                    _c("div", [_vm._v("PLACAS")]),
                    _c("div", [
                      _vm._v(
                        " Tração: " + _vm._s(_vm.rowMDFEData.vehiclePlate) + " "
                      ),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("Reboque: "),
                        _vm.rowMDFEData.mdfeCarInfos &&
                        _vm.rowMDFEData.mdfeCarInfos.length > 0
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.rowMDFEData.mdfeCarInfos[0].vehiclePlate
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm.rowMDFEData.mdfeCarInfos &&
                        _vm.rowMDFEData.mdfeCarInfos.length > 1
                          ? _c("span", [
                              _vm._v(
                                "，" +
                                  _vm._s(
                                    _vm.rowMDFEData.mdfeCarInfos[1].vehiclePlate
                                  )
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "font-weight": "bold" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      border: "1px solid #000",
                      padding: "10px",
                    },
                  },
                  [
                    _c("div", [
                      _c("div", [_vm._v("DESTINO DA PRESTAÇÃO")]),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.rowMDFEData.endCityName) +
                            " / " +
                            _vm._s(_vm.rowMDFEData.endUf)
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { flex: "1", padding: "10px" } },
                  [
                    _c("div", [_vm._v("MOTORISTAS (CPF/NOME)")]),
                    _vm._l(_vm.rowMDFEData.drivers, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticStyle: { padding: "10px 0" } },
                        [
                          _c("div", [_vm._v(_vm._s(item.cpf))]),
                          _c("div", [_vm._v(_vm._s(item.name))]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]),
          _c("div", { staticStyle: { flex: "1", border: "1px solid #000" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        "font-weight": "bold",
                        "text-align": "center",
                      },
                    },
                    [_vm._v("D A M D F E")]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-weight": "bold",
                        "text-align": "center",
                      },
                    },
                    [
                      _vm._v(
                        "DOCUMENTO AUXILIAR DE MANIFESTO ELETRÔNICO DE DOCUMENTOS FISCAIS"
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", height: "54px" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { flex: "1", border: "1px solid #000" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("SÉRIE")]
                          ),
                          _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.serie))]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { flex: "1", border: "1px solid #000" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("NÚMERO")]
                          ),
                          _c("div", [
                            _vm._v(_vm._s(_vm.rowMDFEData.documentNumber)),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { flex: "1", border: "1px solid #000" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("MODAL")]
                          ),
                          _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.modal))]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { flex: "1", border: "1px solid #000" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("MODELO")]
                          ),
                          _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.modelo))]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c("div", { staticStyle: { width: "200px" } }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticStyle: { border: "1px solid #000", padding: "5px" } },
                  [
                    _c("div", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("DATA/HORA DE EMISSÃO"),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.mdfeCreatDate))]),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { border: "1px solid #000", padding: "5px" } },
                  [
                    _c("div", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v("Nº PROTOCOLO"),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.protocolNumber))]),
                  ]
                ),
              ]),
            ]),
            _c("div", [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "text-align": "center",
                  },
                },
                [_vm._v("CONTROLE DO FISCO")]
              ),
              _vm._m(1),
              _c("div", [
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _vm._v(
                    " Chave de acesso para consulta em https://dfe-portal.svrs.rs.gov.br/MDFe/Consulta "
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.rowMDFEData.mdfeKey))]
                ),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              color: "#000",
              "text-align": "center",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { flex: "1", border: "1px solid #000" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("Quantidade de CT-es"),
                ]),
                _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.cteQuantity))]),
              ]
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", border: "1px solid #000" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("Valor Total do Frete"),
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm.formatNumber(_vm.pdfData.totalFrete))),
                ]),
              ]
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", border: "1px solid #000" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("Valor Total da Carga"),
                ]),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.formatNumber(_vm.rowMDFEData.productAmount))
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", border: "1px solid #000" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("Peso Total da Carga"),
                ]),
                _c("div", [_vm._v(_vm._s(_vm.rowMDFEData.cargaPeso))]),
              ]
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", border: "1px solid #000" } },
              [
                _c("div", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("Valor Total do ICMS"),
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm.formatNumber(_vm.pdfData.totalIcms))),
                ]),
              ]
            ),
          ]
        ),
        _c(
          "div",
          { staticStyle: { border: "1px solid #000", color: "#000" } },
          [
            _c(
              "div",
              { staticStyle: { "font-weight": "bold", "font-size": "16px" } },
              [_vm._v("Usuário: " + _vm._s(_vm.rowMDFEData.userEmail))]
            ),
            _c(
              "ul",
              [
                _c("li", [
                  _c("span", { staticClass: "listItem" }),
                  _vm._v(
                    "SEGURADORA: " +
                      _vm._s(_vm.rowMDFEData.insuranceCompany) +
                      " NUM APOLICE SEGUROS: " +
                      _vm._s(_vm.rowMDFEData.policyNo)
                  ),
                ]),
                _c("li", [
                  _c("span", { staticClass: "listItem" }),
                  _vm._v(
                    "AUTORIZACAO TRANSSAT: MOTORISTA " +
                      _vm._s(_vm.rowMDFEData.driverCpf) +
                      " - PLACA " +
                      _vm._s(_vm.rowMDFEData.vehiclePlate)
                  ),
                ]),
                _c("li", [
                  _c("span", { staticClass: "listItem" }),
                  _vm._v(
                    "PLACA " +
                      _vm._s(_vm.rowMDFEData.vehiclePlate) +
                      " - RENAVAM " +
                      _vm._s(_vm.rowMDFEData.renavam) +
                      " - PROPRIETARIO " +
                      _vm._s(_vm.rowMDFEData.vehiclePropCnpj) +
                      " " +
                      _vm._s(_vm.rowMDFEData.vehiclePropName) +
                      " IE " +
                      _vm._s(_vm.rowMDFEData.company.ie) +
                      " - RNTRC " +
                      _vm._s(_vm.rowMDFEData.company.rntrc)
                  ),
                ]),
                _vm.rowMDFEData.mdfeCarInfos &&
                _vm.rowMDFEData.mdfeCarInfos.length > 0
                  ? _vm._l(
                      _vm.rowMDFEData.mdfeCarInfos,
                      function (item, index) {
                        return _c("li", { key: index }, [
                          _c("span", { staticClass: "listItem" }),
                          _vm._v(
                            "PLACA " +
                              _vm._s(item.vehiclePlate) +
                              " - RENAVAM " +
                              _vm._s(item.renavam) +
                              " "
                          ),
                        ])
                      }
                    )
                  : _vm._e(),
                _c("li", [
                  _c("span", { staticClass: "listItem" }),
                  _vm._v(
                    "DATA/HORA DO INICIO DA VIAGEM: " +
                      _vm._s(_vm.rowMDFEData.mdfeStartDate)
                  ),
                ]),
                _c(
                  "li",
                  [
                    _c("span", { staticClass: "listItem" }),
                    _vm._v("UFS DO PERCURSO: "),
                    _vm._l(_vm.rowMDFEData.throughUF, function (item, index) {
                      return _c("span", { key: index }, [_vm._v(_vm._s(item))])
                    }),
                  ],
                  2
                ),
              ],
              2
            ),
          ]
        ),
      ]),
      _c(
        "div",
        {
          ref: "virtualContainer",
          staticClass: "virtual-scroll-container",
          on: { scroll: _vm.handleScroll },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "5px",
                "font-weight": "bold",
                "text-align": "center",
                border: "1px solid #000",
                color: "#000",
                "margin-top": "110px",
              },
            },
            [_vm._v("Gaiola: G5")]
          ),
          _c(
            "div",
            {
              staticClass: "virtual-scroll-placeholder",
              style: { height: _vm.totalHeight + "px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "virtual-scroll-content",
                  style: { transform: "translateY(" + _vm.offsetY + "px)" },
                },
                _vm._l(_vm.visibleItems, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: _vm.visibleStartIndex + index,
                      staticClass: "pdfItem",
                      staticStyle: {
                        color: "#000",
                        "font-size": "14px",
                        border: "1px solid #000",
                        "margin-bottom": "10px",
                      },
                      attrs: {
                        "data-item-index": _vm.visibleStartIndex + index,
                      },
                    },
                    [
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("CTRC")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s("VIA108388-1")),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("CT-e")]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  padding: "0 5px",
                                  "line-height": "14px",
                                },
                              },
                              [_vm._v(_vm._s(item.invoiceKey))]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("REMETENTE")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(item.remetente.cnpj)),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("DESTINATARIO")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(item.destinatario.name)),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("UF")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(item.endUf)),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("CIDADE DESTIN")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(item.endCity)),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("KgReal")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(item.peso)),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("KgCalc")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(item.peso)),
                            ]),
                          ]
                        ),
                        _vm._m(2, true),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("Val Mercad")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(
                                _vm._s(_vm.formatNumber(item.productAmount))
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("Val Frete")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(_vm.formatNumber(item.frete))),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { flex: "1", "font-weight": "bold" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid #000",
                                  height: "50px",
                                },
                              },
                              [_vm._v("Val ICMS")]
                            ),
                            _c("div", { staticStyle: { padding: "0 5px" } }, [
                              _vm._v(_vm._s(_vm.formatNumber(item.icmsAmount))),
                            ]),
                          ]
                        ),
                        _vm._m(3, true),
                        _vm._m(4, true),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            color: "#000",
                            "font-weight": "bold",
                            padding: "10px",
                          },
                        },
                        [
                          _c("div", { staticStyle: { flex: "1" } }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "15px" } },
                              [_vm._v("Doc Fisc / Vol :")]
                            ),
                            _vm._v(" " + _vm._s(item.invoiceKey) + " "),
                          ]),
                          _c("div", { staticStyle: { width: "80px" } }, [
                            _vm._v("/ 1"),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            color: "#000",
                            "font-weight": "bold",
                            padding: "10px",
                          },
                        },
                        [
                          _c("div", { staticStyle: { flex: "1" } }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "15px" } },
                              [_vm._v("Nº AVERBACAO:")]
                            ),
                            _vm._v(" " + _vm._s(item.averb) + " "),
                          ]),
                          _c("div", { staticStyle: { flex: "1" } }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "15px" } },
                              [_vm._v("PEDIDO: ")]
                            ),
                            _vm._v(_vm._s(item.packageNumber) + " "),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
      _vm._m(5),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { border: "1px solid #000", padding: "5px" } },
      [
        _c("div", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("FOLHA"),
        ]),
        _c("div", [_vm._v("01/01")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { display: "flex" } }, [
      _c("div", { staticStyle: { flex: "1" } }, [
        _c("img", { attrs: { id: "barcode" } }),
      ]),
      _c("div", [
        _c("div", {
          staticStyle: { width: "130px", height: "110px" },
          attrs: { id: "qrcode" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { flex: "1", "font-weight": "bold" } }, [
      _c("div", { staticStyle: { border: "1px solid #000", height: "50px" } }, [
        _vm._v("QVOL"),
      ]),
      _c("div", { staticStyle: { padding: "0 5px" } }, [_vm._v("1")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { flex: "1", "font-weight": "bold" } }, [
      _c("div", { staticStyle: { border: "1px solid #000", height: "50px" } }, [
        _vm._v("T"),
      ]),
      _c("div", { staticStyle: { padding: "0 5px" } }, [_vm._v("C")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { flex: "1", "font-weight": "bold" } }, [
      _c("div", { staticStyle: { border: "1px solid #000", height: "50px" } }, [
        _vm._v("SET"),
      ]),
      _c("div", { staticStyle: { padding: "0 5px" } }, [_vm._v("761")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: { color: "#000", "margin-top": "20px" },
        attrs: { id: "pdfFooter" },
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              color: "#000",
              "margin-top": "20px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  flex: "1",
                  border: "1px solid #000",
                  "padding-bottom": "40px",
                },
              },
              [_vm._v(" SAIDA DATA/HORA ")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  flex: "1",
                  border: "1px solid #000",
                  "padding-bottom": "40px",
                },
              },
              [_vm._v(" CHEGADA DATA/HORA ")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  flex: "1",
                  border: "1px solid #000",
                  "padding-bottom": "40px",
                },
              },
              [_vm._v(" MOTORISTA/ASSINATURA ")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  flex: "1",
                  border: "1px solid #000",
                  "padding-bottom": "40px",
                },
              },
              [_vm._v(" CONFERENTE/ASSINATURA ")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  flex: "1",
                  border: "1px solid #000",
                  "padding-bottom": "40px",
                },
              },
              [_vm._v(" MANIFESTO OPERACIONAL - DESTINO ")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }